export interface Selection {
    seq: number;
    value: number;
    text: string;
}

export class NoteProfile {
    DropTitle: string;
    NotesTitle: string;
    DropdownEntries: Selection[];

    constructor(data) {

        if (data) {
            this.DropTitle = data.DropTitle;
            this.NotesTitle = data.NotesTitle;

            this.DropdownEntries = data.DropDownEntries;
        }

    }

    copy() {
        const ret = {
            DropTitle: this.DropTitle,
            NotesTitle: this.NotesTitle,
            DropdownEntries: []
        };

        this.DropdownEntries.forEach(n => {
            ret.DropdownEntries.push({
                seq: n.seq.toString(),
                value: n.value.toString(),
                text: n.text
            });
        });

        return ret;
    }
}
